import { title } from "../title";

export const projectTitle = {
  mixins: [title],
  computed: {
    project() {
      return (
        this.$store.getters["projectStore/getList"].find(
          i => i.id === this.project_id
        ) || {}
      );
    }
  },
  watch: {
    project() {
      this.setTitle();
    }
  },
  methods: {
    setTitle() {
      let { chain, index } = this.getArgumentForTitle();
      chain.unshift(this.project.name);
      chain = chain.filter(el => el);
      this.$store.dispatch("titleStore/setTitle", {
        chain,
        index
      });
    }
  }
};
